export const Vinyl = ({ size = 340, spinning = true, className = "" }) => (
  <div
    data-testid="vinyl-record"
    className={`relative rounded-full ${spinning ? "vinyl-spin" : ""} ${className}`}
    style={{
      width: size,
      height: size,
      background:
        "repeating-radial-gradient(circle at center, #0d0e14 0px, #0d0e14 3px, #181a24 4px, #0d0e14 6px)",
      boxShadow: "0 0 60px rgba(255,183,3,0.18), inset 0 0 40px rgba(0,0,0,0.8)",
    }}
    aria-hidden
  >
    <div
      className="absolute rounded-full"
      style={{
        inset: "31%",
        background: "linear-gradient(135deg, #FFB703 0%, #FB8500 100%)",
        boxShadow: "0 0 24px rgba(255,183,3,0.4)",
      }}
    />
    <div className="absolute rounded-full bg-obsidian" style={{ inset: "47.5%" }} />
  </div>
);
